// src/components/Navbar/Navbar.jsx

import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MenuIcon, BackIcon } from './Icons';
import './Navbar.css';

const menuItems = [
  { id: 'home', label: 'Home' },
  { id: 'o-hotel', label: 'O Hotel' },
  { id: 'acomodacoes', label: 'Acomodações' },
  { id: 'programacao', label: 'Programação' },
  { id: 'sao-lourenco', label: 'São Lourenço' },
  { id: 'contato', label: 'Contato' },
  { id: 'reservas', label: 'Reservas', isButton: true }
];

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [isAtTop, setIsAtTop] = useState(true);
  const [isCompact, setIsCompact] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    const isHomePage = path === '/';

    if (!isHomePage) {
      setIsAtTop(false);
      setIsCompact(true);
      
      // --- ALTERAÇÃO AQUI ---
      if (path.startsWith('/programacao')) {
        setActiveSection('programacao');
      } else if (path.startsWith('/acomodacoes')) {
        setActiveSection('acomodacoes');
      } else if (path.startsWith('/sao-lourenco')) {
        setActiveSection('sao-lourenco');
      } else if (path.startsWith('/estrutura')) { // Adicionada a verificação para a página de estrutura
        setActiveSection('o-hotel'); // Marca 'O Hotel' como ativo
      } else {
        setActiveSection('');
      }
      return;
    }

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsAtTop(scrollPosition < 10);
      setIsCompact(scrollPosition > 100);
      let currentSectionId = 'home';
      const sections = document.querySelectorAll('#home, .fade-in-section[id]');
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (scrollPosition >= section.offsetTop - 150) {
          currentSectionId = section.id;
          break;
        }
      }
      setActiveSection(currentSectionId);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);
  
  useEffect(() => {
    // Este efeito agora só precisa se preocupar com o scroll inicial,
    // a lógica principal foi movida para a HomePage
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuOpen && menuRef.current && !menuRef.current.contains(event.target)) {
        const menuButton = document.querySelector('.mobile-menu-button');
        if (!menuButton?.contains(event.target)) {
          setMobileMenuOpen(false);
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [mobileMenuOpen]);
  
  const navigateToSection = (sectionId) => {
    if (sectionId === 'home') {
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate(`/#${sectionId}`);
    }
    setMobileMenuOpen(false);
  };
  
  const navigateToHomeTop = () => navigateToSection('home');

  const handleReservasClick = () => {
    window.open('https://wa.me/+5535988171649', '_blank');
    setMobileMenuOpen(false); 
  };

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  return (
    <>
      <nav className={`main-menu ${isCompact ? 'compact' : ''} ${isAtTop ? 'at-top' : ''} ${mobileMenuOpen ? 'menu-open' : ''}`}>
        {!mobileMenuOpen && (
          <div className="logo-container">
            <img 
              src="/images/alzira-imperial-logo.webp" 
              alt="Logo Alzira Imperial Hotel" 
              className="logo-image"
              onClick={navigateToHomeTop}
            />
          </div>
        )}
        
        <button 
          className="mobile-menu-button" 
          onClick={toggleMobileMenu}
          aria-label={mobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}
        >
          {mobileMenuOpen ? <BackIcon /> : <MenuIcon />}
        </button>
        
        <ul className="nav-links desktop-menu">
          {menuItems.map(({ id, label, isButton }) => (
            <li key={id}>
              <button 
                onClick={id === 'reservas' ? handleReservasClick : () => navigateToSection(id)}
                className={`${activeSection === id ? 'active' : ''} ${isButton ? 'reserva-btn' : ''}`}
                aria-current={activeSection === id ? 'page' : undefined}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div ref={menuRef} className={`mobile-menu-container ${mobileMenuOpen ? 'open' : ''}`}>
        {mobileMenuOpen && (
          <div className="mobile-menu-header">
            <div className="mobile-logo-container">
              <img 
                src="/images/alzira-imperial-logo.webp" 
                alt="Hotel Alzira Imperial" 
                className="mobile-logo-image"
                onClick={() => {
                  navigateToHomeTop();
                  setMobileMenuOpen(false);
                }}
              />
            </div>
            <button 
              className="mobile-back-button" 
              onClick={() => setMobileMenuOpen(false)}
              aria-label="Fechar menu"
            >
              <BackIcon />
            </button>
          </div>
        )}
        
        <ul className="mobile-menu">
          {menuItems.map(({ id, label, isButton }) => (
            <li key={id}>
              <button 
                onClick={id === 'reservas' ? handleReservasClick : () => navigateToSection(id)}
                className={`${activeSection === id ? 'active' : ''} ${isButton ? 'reserva-btn' : ''}`}
                aria-current={activeSection === id ? 'page' : undefined}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Navbar;